import Head from "next/head";
import type {NextPage} from "next";
import {handleLogout} from "components/utils"; import React from "react";
import {BlogsView} from "../components/blogs";
import FooterView from "../components/common/Footer";
import {getAllPosts} from '../lib/api'
import Post from "../interfaces/post";
import MoreStories from "../components/posts/more-stories";

type Props = {
    allPosts: Post[]
}

const Blogs: NextPage = (props: { allPosts }) => {
    return (
        <>
            <div>
                <Head>
                    <title>QMe - Clinic and Hospital Management | Blogs</title>
                    <link rel="canonical" href="https://www.qme.co.in/" />
                    <meta property="og:image" content="/og.png"/>
                    <meta property="og:title" content="Effortless Patient Management & Token-Based Appointments | QME"/>
                    <meta property="og:description" content="Experience efficient stock control, innovative token-based scheduling, and smart queues for unparalleled patient experiences at QME. Read for more!"/>
                    <meta name="twitter:image" content="/og.png"/>
                    <meta name="robots" content="index, follow"/>
<script
                    key="schema-jsonld"
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "Organization",
                            "name": "QMe - Hospital and Clinic Management",
                            "image": "https://www.qme.co.in/logo.svg",
                            "description": "Effortless patient management, efficient stock and inventory control, unparalleled patient experience through innovative token-based appointments and smart queues and much more.",
                            "url": "https://www.qme.co.in/",
                            "telephone": "+919971513514",
                            "emailid": "contact@qme.co.in",
                            "sameAs": ["https://www.facebook.com/qmehmis", "https://www.instagram.com/qmehmis", "https://www.youtube.com/@qmehmis"]
                        }, null, "\t") }}
                />
<script
                    key="schema-jsonld"
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "Organization",
                            "name": "QMe - Hospital and Clinic Management",
                            "image": "https://www.qme.co.in/logo.svg",
                            "description": "Effortless patient management, efficient stock and inventory control, unparalleled patient experience through innovative token-based appointments and smart queues and much more.",
                            "url": "https://www.qme.co.in/",
                            "telephone": "+919971513514",
                            "emailid": "contact@qme.co.in",
                            "sameAs": ["https://www.facebook.com/qmehmis", "https://www.instagram.com/qmehmis", "https://www.youtube.com/@qmehmis"]
                        }, null, "\t") }}
                />
                    <meta name="description" content="QMe - Clinic and Hospital Management | Blogs"/>
                    <meta name="keywords" content="hospital management and information system"/>
                </Head>
                <div className="bg-white">
                    {props.allPosts && props.allPosts.length > 1 && <div className="row bg-white hero shadow-sm">
                        <div className="col col-12 col-lg-10 offset-lg-1">
                            <MoreStories posts={props.allPosts}/>
                        </div>
                    </div>}</div>
                <FooterView/>
            </div>

        </>
    )
};


export default Blogs;

export const getStaticProps = async () => {
    const allPosts = getAllPosts([
        'title',
        'date',
        'slug',
        'author',
        'coverImage',
        'excerpt',
    ])

    return {
        props: {allPosts},
    }
}